import { ReactElement } from 'react';

export type Props = {
    children: ReactElement | ReactElement[]
}

export interface MenuItemType {
    value: string;
    label: string;
}

export const DefaultMenuItem: MenuItemType = {
    value: ' ',
    label: 'Kérem válasszon!',
};

export enum TAB_VIEW {
    DEVICE,
    LINE,
    WORKPLACE,
    COMPANY_DEVICE
}